// extracted by mini-css-extract-plugin
export default {"settings":"J_k0S","preview":"YVjfY","inner":"cuZIJ","title":"KubDg","description":"Fo9YR","difficulty":"IjYQj","difficultyTitle":"RZSyK","free":"FS_9Y","freeText":"m5ZqE"};